module.exports = __webpack_public_path__ + "img/navBarLogoBes.0ecf9764.png";